import React from 'react';
import { Link } from 'react-router-dom';
import './LegalPages.css';

function PrivacyPolicy() {
  return (
    <div className="legal-page">
      <header className="legal-header">
        <Link to="/" className="logo-link">
          <img src="/logoBrivefood.png" alt="BriveFood" className="logo" />
        </Link>
        <h1 className="page-title">Politique de Confidentialité</h1>
      </header>

      <main className="legal-content">
        <p className="last-updated">Dernière mise à jour : {new Date().toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' })}</p>

        <section className="legal-section">
          <h2>1. Introduction</h2>
          <p>
            Bienvenue sur BriveFood. Nous nous engageons à protéger la confidentialité et la sécurité de vos données personnelles.
            Cette politique de confidentialité décrit comment nous collectons, utilisons, stockons et protégeons vos informations
            lorsque vous utilisez notre application mobile et nos services.
          </p>
        </section>

        <section className="legal-section">
          <h2>2. Données Collectées</h2>
          <p>Nous collectons les types de données suivants :</p>
          <ul>
            <li><strong>Données d'identification :</strong> nom, prénom, adresse email, numéro de téléphone</li>
            <li><strong>Données de livraison :</strong> adresse de livraison, instructions de livraison</li>
            <li><strong>Données de paiement :</strong> informations de carte bancaire (traitées de manière sécurisée via nos partenaires de paiement)</li>
            <li><strong>Données de commande :</strong> historique des commandes, préférences alimentaires</li>
            <li><strong>Données techniques :</strong> adresse IP, type d'appareil, système d'exploitation, données de géolocalisation</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>3. Utilisation des Données</h2>
          <p>Vos données sont utilisées pour :</p>
          <ul>
            <li>Traiter et livrer vos commandes</li>
            <li>Gérer votre compte utilisateur</li>
            <li>Vous envoyer des confirmations de commande et des mises à jour</li>
            <li>Améliorer nos services et votre expérience utilisateur</li>
            <li>Vous proposer des offres personnalisées (avec votre consentement)</li>
            <li>Respecter nos obligations légales</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>4. Partage des Données</h2>
          <p>Nous pouvons partager vos données avec :</p>
          <ul>
            <li><strong>Nos partenaires de livraison :</strong> pour assurer la livraison de vos commandes</li>
            <li><strong>Nos prestataires de paiement :</strong> pour traiter vos transactions de manière sécurisée</li>
            <li><strong>Les autorités compétentes :</strong> lorsque la loi l'exige</li>
          </ul>
          <p>Nous ne vendons jamais vos données personnelles à des tiers.</p>
        </section>

        <section className="legal-section">
          <h2>5. Sécurité des Données</h2>
          <p>
            Nous mettons en œuvre des mesures de sécurité techniques et organisationnelles appropriées pour protéger
            vos données contre tout accès non autorisé, modification, divulgation ou destruction. Cela inclut le
            chiffrement des données, des protocoles de sécurité SSL/TLS et un accès restreint aux données personnelles.
          </p>
        </section>

        <section className="legal-section">
          <h2>6. Conservation des Données</h2>
          <p>
            Nous conservons vos données personnelles aussi longtemps que nécessaire pour fournir nos services et
            respecter nos obligations légales. Les données de compte sont conservées tant que votre compte est actif.
            Les données de commande sont conservées pendant 5 ans à des fins comptables et légales.
          </p>
        </section>

        <section className="legal-section">
          <h2>7. Vos Droits</h2>
          <p>Conformément au RGPD, vous disposez des droits suivants :</p>
          <ul>
            <li><strong>Droit d'accès :</strong> obtenir une copie de vos données personnelles</li>
            <li><strong>Droit de rectification :</strong> corriger vos données inexactes ou incomplètes</li>
            <li><strong>Droit à l'effacement :</strong> demander la suppression de vos données</li>
            <li><strong>Droit à la portabilité :</strong> recevoir vos données dans un format structuré</li>
            <li><strong>Droit d'opposition :</strong> vous opposer au traitement de vos données</li>
            <li><strong>Droit de limitation :</strong> demander la limitation du traitement</li>
          </ul>
          <p>Pour exercer ces droits, contactez-nous via l'application.</p>
        </section>

        <section className="legal-section">
          <h2>8. Cookies</h2>
          <p>
            Notre application et notre site web peuvent utiliser des cookies et technologies similaires pour améliorer
            votre expérience. Vous pouvez gérer vos préférences de cookies dans les paramètres de votre navigateur.
          </p>
        </section>

        <section className="legal-section">
          <h2>9. Modifications</h2>
          <p>
            Nous nous réservons le droit de modifier cette politique de confidentialité à tout moment.
            Les modifications prendront effet dès leur publication. Nous vous informerons de tout changement
            significatif par email ou via l'application.
          </p>
        </section>

        <section className="legal-section">
          <h2>10. Contact</h2>
          <p>Pour toute question concernant cette politique de confidentialité, contactez-nous :</p>
          <div className="contact-info">
            <p><strong>BriveFood</strong></p>
            <p>Email : brivefood@gmail.com</p>
          </div>
        </section>
      </main>

      <footer className="legal-footer">
        <div className="footer-links">
          <Link to="/">Télécharger l'App</Link>
          <Link to="/politique-de-confidentialite">Politique de Confidentialité</Link>
          <Link to="/conditions-generales">Conditions Générales d'Utilisation</Link>
        </div>
        <p className="copyright">&copy; {new Date().getFullYear()} BriveFood. Tous droits réservés.</p>
      </footer>
    </div>
  );
}

export default PrivacyPolicy;
